import { UtilsService } from 'src/app/services/utils/utils.service';
import { UserService } from 'src/app/services/user/user.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import {
  PaymentServicesService,
  IProviderServices,
} from './../../../services/payment-services/payment-services.service';
import { PopoverComponent } from './../../../components/popover/popover.component';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { PopoverController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { Component, OnInit } from '@angular/core';
import { IPaymentServices, fieldsPayment } from './IPayment-services.model';
import * as moment from 'moment';

@Component({
  selector: 'app-payment-services',
  templateUrl: './payment-services.page.html',
  styleUrls: ['./payment-services.page.scss'],
})
export class PaymentServicesPage implements OnInit {
  PaymentData: IPaymentServices;
  imageProvider = '';
  dataProvider: IProviderServices[];
  points: any;
  fields: Array<fieldsPayment> = [];
  PaymentServicesForm: FormGroup;
  LOADER_ID = 'paymentServices-form';
  MaxDate = moment().format('YYYY-MM-DD');
  MinDate = moment().add(10, 'd').format('YYYY-MM-DD');
  loadingForm = false;
  dataOrder: {
    programId: any;
    companyId: any;
    uid: any;
    sku: any;
    quantity: number;
    appId: any;
    user: {
      username: any;
      name: any;
      lastname: any;
      docId: any;
      email: any;
      phone: any;
      docType: any;
    };
    publicServices: { amount: any; paymentReference: any; paymentDate: Date };
  };
  userinfo: { name: any; docId: any; lastname: any; docType: any } = {
    name: '',
    docId: '',
    lastname: '',
    docType: '',
  };
  totalbyUsyng;

  constructor(
    public languageService: LanguagesService,
    private remoteConfig: RemoteConfigService,
    private formBuilder: FormBuilder,
    private storageServices: StorageService,
    private loaderService: LoaderService,
    private alertService: AlertService,
    private router: Router,
    private popoverController: PopoverController,
    private paymentService: PaymentServicesService,
    private userService: UserService,
    private utilsService: UtilsService
  ) {
    this.PaymentServicesForm = this.formBuilder.group({});
  }
  async ngOnInit() {
    this.remoteConfig
      .getSettingPaymentServicesConfig()
      .subscribe((data: IPaymentServices) => {
        this.PaymentData = data;
        console.log(data);
        this.getPoints();
      });
    this.generateForm();
    this.getUserInfo();
  }
  ionViewDidEnter() {
    this.getPoints();
    this.PaymentServicesForm.reset();
  }

  getPoints() {
    console.log('getPoints', this.PaymentData?.viewPoint);

    if (this.PaymentData?.viewPoint) {
      this.utilsService.getUserPoints().then((result: any) => {
        console.log(result);

        this.points = result;
      });
    }
  }

  /* ionViewDidEnter(){
    this.images = []
   } */

  setProviderImage($event) {
    this.imageProvider = this.dataProvider.find((provider) => {
      return provider.sku == $event.target.value;
    })?.image;
  }

  get f() {
    return this.PaymentServicesForm.controls;
  }

  async generateForm() {
    const fieldsData = await this.remoteConfig
      .getSettingPaymentServicesConfig()
      .toPromise();
    this.fields = fieldsData.fields;
    let validations = [];
    this.fields.map(async (field) => {
      validations = [];
      field.validations?.includes('required')
        ? validations.push(Validators.required)
        : '';
      field.validations?.includes('min')
        ? validations.push(
            Validators.minLength(field.validations.split(':')[0])
          )
        : '';
      field.validations?.includes('max')
        ? validations.push(
            Validators.maxLength(field.validations.split(':')[0])
          )
        : '';

      if (field.type == 'number' && field.isPhone) {
        validations.push(Validators.pattern(/^[0-9]*$/));
      }

      await this.PaymentServicesForm.addControl(
        field.name,
        field.subfields
          ? this.formBuilder.array([], validations)
          : this.formBuilder.control('', validations)
      );
      if (field.type == 'select' && field.key == 'id') {
        this.dataProvider = await this.paymentService.getProviders();
        this.dataProvider.forEach((data) => {
          const provider = { label: data.name, value: data.sku };
          field.options.push(provider);
        });
      }
    });
    this.f['id'].valueChanges.subscribe(() => {
      this.calculateValueService();
    });
    this.f['price'].valueChanges.subscribe(() => {
      this.totalbyUsyng = '';
    });
    this.getInputPrice();
  }

  getInputPrice() {
    let x;
    const intervalId = setInterval(() => {
      const idPrice = document.getElementById('price');

      if (idPrice) {
        clearInterval(intervalId);
        idPrice.addEventListener('blur', () => {
          this.calculateValueService();
        });
      }
      if (++x === 10) {
        clearInterval(intervalId);
      }
    }, 1000);
  }
  cancel() {
    this.PaymentServicesForm.reset();
    this.router.navigateByUrl('app/home');
  }
  getUserInfo() {
    this.userService.getUserInfo().subscribe(async (basicUserInfo: any) => {
      this.userinfo.name = basicUserInfo.name;
      this.userinfo.docId = basicUserInfo.gnxCredential1;
      this.userinfo.lastname = basicUserInfo.lastnames;
      this.userinfo.docType = basicUserInfo.docType;
    });
  }

  async calculateValueService() {
    if (this.f['price'].value && this.f['id'].value) {
      this.totalbyUsyng = '...';
      const price = (this.f['price'].value as string)
        .replace(/\./g, '')
        .replace(',', '.')
        .replace(/\./g, '');

      const data = {
        cost: parseInt(price),
        sku: this.f['id'].value,
      };
      const value: any = await this.paymentService.CalculateValueServices(data);
      this.totalbyUsyng = value.valueInPoints;
      console.log('calculateValueService', value);
    }
  }

  async sendForm() {
    console.log({ ...this.PaymentServicesForm });
    this.loadingForm = true;
    this.loaderService.presentLoading(this.LOADER_ID);

    if (this.totalbyUsyng && this.totalbyUsyng != '...') {
      if (this.PaymentServicesForm.valid) {
        try {
          const claims = await this.storageServices.get('gnx-claims');
          console.log(claims);
          await this.statusOrderhandler({ status: 'order_loading' });
          this.dataOrder = {
            programId: claims.programs[0].split('/')[3],
            companyId: claims.programs[0].split('/')[1],
            uid: claims.uid,
            sku: this.f['id'].value,
            quantity: 1,
            appId: claims.app_id,
            user: {
              username: claims.username,
              name: this.userinfo.name,
              lastname: this.userinfo.lastname,
              docId: this.userinfo.docId,
              email: claims.email,
              phone: this.f['phone'].value,
              docType: this.userinfo.docType,
            },
            publicServices: {
              amount: Number(
                this.f['price'].value.replaceAll('.', '').replaceAll(',', '')
              ),
              paymentReference: this.f['Reference'].value,
              paymentDate: this.f['dateLimit'].value,
            },
          };
          this.paymentService
            .savepaymentServices({ ...this.dataOrder })
            .then(async (data: any) => {
              console.log(data);
              if (
                data.code === 'NOT_FOUND' ||
                data.code === 'INSUFFICIENT_POINTS'
              ) {
                this.statusOrderhandler({
                  status: 'order_error',
                  ...this.dataOrder,
                  response: data,
                });
              } else if (data.code === 'created') {
                this.PaymentServicesForm.reset();
                this.statusOrderhandler({
                  status: 'order_success',
                  ...this.dataOrder,
                  response: data,
                });
                this.router.navigate([
                  'app',
                  'payment-services',
                  'requestReceived',
                  data.id,
                  'OK',
                ]);
                this.loadingForm = false;
              } else {
                this.statusOrderhandler({
                  status: 'order_error',
                  ...this.dataOrder,
                  response: data,
                });
              }
              this.loadingForm = false;
              this.PaymentServicesForm.reset();
              await this.loaderService.cancelLoader(this.LOADER_ID);
            })
            .catch((error) => {
              console.log('catch((error', error);
              this.loaderService.cancelLoader(this.LOADER_ID);
              this.loadingForm = false;
              this.statusOrderhandler({
                status: 'order_error',
                ...this.dataOrder,
                response: error,
              });
            });

          this.loaderService.cancelLoader(this.LOADER_ID);
        } catch (error) {
          await this.loaderService.cancelLoader(this.LOADER_ID);
          this.alertService.showErrorAlert(`Error, ${error}`);
        }
      } else {
        this.loaderService.cancelLoader(this.LOADER_ID);
        this.alertService.presentAlert(
          'Debes diligenciar los campos requeridos'
        );
      }
    } else {
      this.loadingForm = false;
      this.loaderService.cancelLoader(this.LOADER_ID);
      this.alertService.presentAlert(
        'Intente una vez se haya realizado el calculo de los coins'
      );
    }
  }

  async statusOrderhandler(orderStatus) {
    console.log('orderStatus', orderStatus);

    if (orderStatus.status === 'order_success') {
      /* await this.alertService.presentOrderStatus(
        "Tu Orden fue creada correctamente",
        "checkmark-circle",
        "gnx-icon-order-status-success"
      ); */
      this.alertService.presentAlert('Tu Orden fue creada correctamente');
      setTimeout(() => {
        this.alertService.alertController.dismiss();
        /*  this.tagsService.setEventTag(
           "rewards_category_confirm",
           "rewards_category_confirm_clicked",
           false,
           true
         ); */
        // return this.routerService.redirect("app/orders-success");
      }, 2000);
    }
    if (orderStatus.status === 'order_loading') {
      /* return await this.alertService.presentOrderStatus(
        "Estamos creando tu orden",
        "cloud-upload-outline",
        "gnx-icon-order-status-loading"
      ); */
      this.alertService.presentAlert('Estamos creando tu orden');
    }
    if (orderStatus.status === 'order_error') {
      if (orderStatus?.response?.code === 'INSUFFICIENT_POINTS') {
        /* await this.alertService.presentOrderStatus(
          "No tienes puntos suficientes",
          "close-circle-outline",
          "gnx-icon-order-status-error"
        ); */
        this.alertService.presentAlert('No tienes coins suficientes');
      } else if (orderStatus?.response?.code === 'PRODUCT_DISABLED') {
        /* await this.alertService.presentOrderStatus(
          "El producto no se encuentra disponible actualmente",
          "close-circle-outline",
          "gnx-icon-order-status-error"
        ); */
        this.alertService.presentAlert(
          'El producto no se encuentra disponible actualmente'
        );
      } else if (orderStatus?.response?.code === 'VALIDATION_STOCK_ERROR') {
        /* await this.alertService.presentOrderStatus(
          "Stock Insuficiente",
          "close-circle-outline",
          "gnx-icon-order-status-error"
        ); */
        this.alertService.presentAlert('Stock Insuficiente');
      } else if (orderStatus.error) {
        /* await this.alertService.presentOrderStatus(
          orderStatus.error,
          "close-circle-outline",
          "gnx-icon-order-status-error"
        ); */
        this.alertService.presentAlert(orderStatus.error);
      } else {
        var errorText = orderStatus?.error ? orderStatus?.error : '';
        /*  await this.alertService.presentOrderStatus(
          `Ups, Tenemos problemas para crear tu orden. No hay bono disponible - ${errorText}`,
          "close-circle-outline",
          "gnx-icon-order-status-error"
        ); */
        this.alertService.presentAlert(
          `Ups, Tenemos problemas para crear tu orden. No hay bono disponible - ${errorText}`
        );
      }
      setTimeout(() => {
        return this.alertService.alertController.dismiss();
      }, 2000);
    }
  }
  async presentPopover(ev: any, field) {
    console.log(field.valueHelp);

    const popover = await this.popoverController.create({
      component: PopoverComponent,
      event: ev,
      translucent: true,
      componentProps: {
        message: field.valueHelp,
      },
    });
    return await popover.present();
  }
  get getTextsIUPagePaymentServices() {
    return this.languageService.textsIU.page_payment_services;
  }

  keyPressNumber($event) {
    return this.utilsService.keyPressNumber($event);
  }
}
